import type { ReactNode } from 'react';

export const symbol_book_4: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M240-80q-50 0-85-35t-35-85v-560q0-50 35-85t85-35h360q24.75 0 42.38 17.62Q660-844.75 660-820v500q0 24.75-17.62 42.37Q624.75-260 600-260H240q-25.5 0-42.75 17.5T180-200q0 25 17.25 42.5T240-140h540v-630q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v630q0 24.75-17.62 42.37Q804.75-80 780-80H240Zm100-240h260v-500H340v500Zm-60 0v-500h-40q-26 0-43 17.25T180-760v457q13-8 27.88-12.5Q222.77-320 240-320h40ZM180-820v517-517Z"
		/>
	</svg>
);
